export default __webpack_public_path__ + "static/media/ecommerce.5487730c.jpg";